import type { FC } from "react";
import type { ImagePreviewProps } from "@/components/MediaPreview/ImagePreview";
import ImagePreview from "@/components/MediaPreview/ImagePreview";

export const DMPreview: FC<ImagePreviewProps> = (props) => <ImagePreview {...props} />;

export default DMPreview;
